/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useContext, memo, useMemo, useState, useCallback, useRef} from 'react';
import { useDrop, useDragLayer } from "react-dnd";
import moment from "moment";
import __ from "lodash";
import SystemContext from "../../SystemContext";
import TripLeg from "./TripLeg";
import Maintenance from "./Maintenance";
import DayHeader from './DayHeader';
//import { TripSvg } from './TripLeg';
import TimeLineBgImages, {widths as timelineBgWidths} from './TimeLineBgImages';
import { Icon, IconButton } from '@material-ui/core';
import AircraftRegWithDefects from './AircraftRegWithDefects';
// import ReactScrollWheelHandler from 'react-scroll-wheel-handler';

const calculateOffsets = (props, scrollLeft, offsets) => {
  const {clientWidth=0, blockSize, startTime, endTime} = props;
  const startHour = moment.utc(startTime).startOf('hour');
  const endHour = moment.utc(endTime).endOf('hour').add(1,'hour');
  const blockCount = moment(endHour).diff(moment(startHour), "hour") + 1;
  const startHourNo = startHour.get('hour');
  const blockDays = [];
  const blockHours = [];
  for (let i = 0; i <= blockCount; i++) {
    blockHours.push({dateTime: moment(startHour).add(i, 'hour').utc().valueOf(), date: moment(startHour).add(i, 'hour').utc().format('DD MMM'), yy: moment(startHour).add(i, 'hour').utc().format('YY'), dow: moment(startHour).add(i, 'hour').utc().format('ddd'), time:moment(startHour).add(i, 'hour').utc().format('HH:mm'), week: moment(startHour).add(i, 'hour').utc().isoWeek()});
    if ((startHourNo+i % 24) === 1) {
      blockDays.push({dateTime: moment(startHour).add(i, 'hour').utc().valueOf(), date: moment(startHour).add(i, 'hour').utc().format('DD MMM'), yy: moment(startHour).add(i, 'hour').utc().format('YY'), dow: moment(startHour).add(i, 'hour').utc().format('ddd'), time:moment(startHour).add(i, 'hour').utc().format('HH:mm'), week: moment(startHour).add(i, 'hour').utc().isoWeek()});
    }
  }

  let blockAtStart = Math.ceil((scrollLeft||0) / blockSize);
  let blockAtEnd = blockCount;
  if (clientWidth) {
    const offset = scrollLeft;
    blockAtEnd = Math.floor((offset+clientWidth) / blockSize);
    if (blockAtEnd >= blockHours.length) blockAtEnd = blockHours.length - 1;
  }
  const timelineSize = (blockCount+1)*blockSize;

  const indexOfMidday = __.findIndex(blockHours, {time:'12:00'});

  const showStartBlock = blockSize > 12 && (timelineSize > clientWidth || indexOfMidday <= 0 || indexOfMidday * blockSize > 300);
  const showEndBlock = blockSize > 12 && (timelineSize > clientWidth || ((indexOfMidday < 0 || indexOfMidday * blockSize < timelineSize - 300) && timelineSize > 600)) ;

  const windowStartDate = showStartBlock && blockHours[blockAtStart]?.date||null;
  const windowEndDate = showEndBlock && blockHours[blockAtEnd]?.date||null;
  const filteredAircraftTrips = null;

  const offset = clientWidth / 2;
  const blockInMiddle = (scrollLeft + (offset - offsets[blockSize])) / blockSize;
  const windowMiddleDate = moment.utc(startTime).add(blockInMiddle, 'hour').toISOString();

  return {blockHours, blockDays, startHour, endHour, showStartBlock, showEndBlock, blockAtStart, blockAtEnd, filteredAircraftTrips, timelineSize, windowStartDate, windowEndDate, windowMiddleDate }
}

const TimeWindow = (props) => {
  const {clientWidth=0, blockSize, colours, offsets, dragTimeUnit, hiddenAircraft = [], selectedTripLegKey} = props;
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  let scrollLeft = props.scrollLeft || -1;
  const deltas = props.deltas;
  const toolTipPinned = props.toolTipPinned;
  let {blockHours, blockDays, startHour, endHour, showStartBlock, showEndBlock, blockAtStart, blockAtEnd, filteredAircraftTrips, timelineSize, windowStartDate, windowEndDate, windowMiddleDate} = calculateOffsets(props, scrollLeft, offsets);

  const [windowDates, setWindowDates] = useState({windowStartDate, windowEndDate});
  if ( windowDates.windowStartDate === "" && windowStartDate !== windowDates.windowStartDate){
    setWindowDates({windowStartDate, windowEndDate, windowMiddleDate});
  }

  let refresh = 0;
  let tripRegistrations = Object.keys((props.aircraftTrips||{}));
  let mxRegistrations = Object.keys((props.aircraftMx||{}));
  let registrations = __.sortBy(__.uniq([...tripRegistrations, ...mxRegistrations]));

  useEffect(() => {
    tripRegistrations = Object.keys((props.aircraftTrips||{}));
    mxRegistrations = Object.keys((props.aircraftMx||{}));
    registrations = __.sortBy(__.uniq([...tripRegistrations, ...mxRegistrations]));

    const handleScrolling = __.throttle((scrollState) => {
      // console.log(scrollState);
      if ((scrollState.scrollLeft === 0 && scrollState.scrollDirection === "left") || (scrollState.scrollLeft >= timelineSize - (clientWidth + 10) && scrollState.scrollDirection === "right") || Math.abs(scrollState.scrollLeft - scrollLeft) > 500){

        scrollLeft = scrollState.scrollLeft;
        const offsetData =  calculateOffsets(props, scrollLeft, offsets);
        startHour = offsetData.startHour;
        endHour = offsetData.endHour;
        blockHours = offsetData.blockHours;
        showStartBlock = offsetData.showStartBlock;
        showEndBlock = offsetData.showEndBlock;
        blockAtStart = offsetData.blockAtStart;
        blockAtEnd = offsetData.blockAtEnd;
        filteredAircraftTrips = offsetData.filteredAircraftTrips;
        timelineSize = offsetData.timelineSize;
        windowStartDate = offsetData.windowStartDate;
        windowEndDate = offsetData.windowEndDate;
        windowMiddleDate = offsetData.windowMiddleDate;
        if (windowStartDate !== windowDates.windowStartDate || windowMiddleDate !== windowDates.windowMiddleDate){
          setWindowDates({windowStartDate, windowEndDate, windowMiddleDate});
        }
        console.log(scrollLeft,  timelineSize - clientWidth);
        if (scrollLeft === 0 && scrollState.scrollDirection === "left") {
          eventBus.trigger('RouteView.TimeWindow.atStart');
          // console.log('At Start');
        }
        if (scrollLeft >= timelineSize - (clientWidth + 10) && scrollState.scrollDirection === "right") {
          eventBus.trigger('RouteView.TimeWindow.atEnd');
          // console.log('At End');
        }
        if (toolTipPinned.current.uuid) {
          toolTipPinned.current = {open: false, uuid: null, selectedScreen: "map"};
        }
      }
    },1000, {leading: true, trailing: true});
    if (eventBus) {
      // console.log('TimeWindow Loaded');
      setTimeout(()=> {
        eventBus.trigger('RouteView.TimeWindow.loaded');
      }, 1);
      eventBus.bind('RouteView.scrolling', handleScrolling);
    }
    return () => {
      //console.log('TimeWindow Unloaded');
      eventBus.trigger('RouteView.TimeWindow.unloaded');
      eventBus.unbind('RouteView.scrolling', handleScrolling);
    }
  }, [eventBus, props.scrollLeft, props.aircraftTrips, props.aircraftMx, props.blockSize, props.deltas, refresh]);

  const rows = {};

  const findFreeRow = (rows, newStartTime, newEndTime, minimumRow = 0) => {
    let rowNo = null;
    const rowCount = rows.length;
    for (let i = minimumRow; i < rowCount; i++) {
      const found = __.findIndex(rows[i], ({startTime, endTime}) => (startTime >= newStartTime && startTime <= newEndTime) || (endTime >= newStartTime && endTime <= newEndTime) || (newStartTime >= startTime && newStartTime <= endTime) || (newEndTime >= startTime && newEndTime <= endTime));
      if (found < 0) {
        rowNo = i;
        break;
      }
    }
    if (rowNo === null) {
      rowNo = rowCount;
      rows.push([]);
    }
    return rowNo;
  }

  const TripLine = (props) => {
    const accept = ["TRIP", "SCHEDULED", "MAINTENANCE"];
    const [{ isOver, canDrop, clientOffset, newTime }, dropRef] = useDrop({
      accept,
      drop: (item, monitor) => {
        if (!item.trip) return;
        const {aircraftReg} = props;
        if (!props.externalAircraft && (item.type === "LEON" || item.type === "TRIP" || item.type === "SCHEDULED")) {
          const {scheduledDepartureTimeUtc, scheduledArrivalTimeUtc} = item.trip;
          const offsetX = monitor.getDifferenceFromInitialOffset().x;
          const offsetXMinutes = offsetX / (blockSize / 60);
          const offsetTimeStd = moment(scheduledDepartureTimeUtc).add(offsetXMinutes, 'minutes');
          const offsetTimeSta = moment(scheduledArrivalTimeUtc).add(offsetXMinutes, 'minutes');
          const newMinutes = offsetTimeStd.get('minutes');
          const fiveMinDiff = newMinutes % (dragTimeUnit||5);
          const newTimeStd = offsetTimeStd.subtract(fiveMinDiff, 'minute').startOf('minute').toISOString();//format('YYYY-MM-DD HH:mm');
          const newTimeSta = offsetTimeSta.subtract(fiveMinDiff, 'minute').startOf('minute').toISOString();//format('YYYY-MM-DD HH:mm');
          const record = {...item.trip, scheduledDepartureTimeUtc: newTimeStd, scheduledArrivalTimeUtc: newTimeSta, aircraftReg, aircraftChanged: aircraftReg !== item.trip.aircraftReg, changed: true};
          eventBus.trigger("RouteView.TimeWindow.droppedTrip", record);
        }
        if (item.type === "MAINTENANCE") {
          const {startCheckDate, endCheckDate} = item.trip;
          const offsetX = monitor.getDifferenceFromInitialOffset().x;
          const offsetXMinutes = offsetX / (blockSize / 60);
          const offsetTimeStd = moment(startCheckDate).add(offsetXMinutes, 'minutes');
          const offsetTimeSta = moment(endCheckDate).add(offsetXMinutes, 'minutes');
          const newMinutes = offsetTimeStd.get('minutes');
          const fiveMinDiff = newMinutes % (dragTimeUnit||5);
          const newTimeStd = offsetTimeStd.subtract(fiveMinDiff, 'minute').format('YYYY-MM-DD HH:mm');
          const newTimeSta = offsetTimeSta.subtract(fiveMinDiff, 'minute').format('YYYY-MM-DD HH:mm');
          eventBus.trigger("RouteView.TimeWindow.droppedMx", {...item.trip, startCheckDate: newTimeStd, endCheckDate: newTimeSta, changed: true});
        }
      },
      canDrop: (item, monitor)=> {
        if (props.externalAircraft) return false;
        if (!item.trip) return;
        const {aircraftReg} = item.trip;
        return accept.indexOf(item.type) >=0 && (aircraftReg.split('-').join('') === props.aircraftReg.split('-').join('') || item.type === "TRIP");
      },
      collect: (monitor) => {
        const {trip} = monitor.getItem()||{};
        const type = monitor.getItemType();
        const {aircraftReg} = trip || {};
        return {
          clientOffset: monitor.getClientOffset(),
          offsetX: monitor.getDifferenceFromInitialOffset()?.x,
          isOver: monitor.isOver() && accept.indexOf(type) >=0 && (aircraftReg.split('-').join('') === props.aircraftReg.split('-').join('') || type === "TRIP"),
          canDrop: monitor.canDrop() && accept.indexOf(type) >=0 && (aircraftReg.split('-').join('') === props.aircraftReg.split('-').join('') || type === "TRIP"),
        }
      }
    })

    return (
      <>
      <div
        ref={dropRef}
        style={{
          marginLeft: -1,
          position: "relative",
          height: (((rows[props.aircraftReg].length) * 30)),
          borderBottom: "1px solid #909090",
          backgroundColor: isOver?props.externalAircraft?"#ff0000":"#50ffff":props.backgroundColor,
          backgroundImage: TimeLineBgImages[props.blockSize],
          backgroundRepeat: "repeat",
          backgroundSize: timelineBgWidths[props.blockSize],
        }}
      >
        {props.renderedTrips}{props.renderedMx}
      </div>
      </>
    );
  }

  const renderTrips = (props) => {
    const {registrations, deltas, aircraftTrips, aircraftMx, editing, canChange, toolTipPinned, showOriginals, canViewDetails, detailAsPanel, userClass} = props;
    // console.debug(` - starting build of rendered trips`);
    const {added, deleted, updated} = {
      added: {},
      deleted: {},
      updated: {},
      ...deltas
    }

    const rendered = registrations.map((aircraftReg, i) => {
      if (hiddenAircraft.indexOf(aircraftReg) >= 0) return null;
      const trips = [...(aircraftTrips[aircraftReg]||[])];
      const deletedTrips = [];
      updated.trips.forEach((trip) => {
        const idx = __.findIndex(trips, {uuid: trip.uuid});
        if (idx < 0) {
          if (trip.aircraftReg === aircraftReg) {
            if (trip.tripState === "DELETED" || trip.tripState === "CANCELLED") {
              deletedTrips.push(trip);
            } else {
              trips.push(trip);
            }
          }
        } else {
          if (trip.tripState === "DELETED" || trip.tripState === "CANCELLED") {
            trips.splice(idx,1);
            deletedTrips.push(trip);
          } else {
            trips[idx] = trip;
          }
        }
      });
      // added.trips.forEach((trip) => {
      //   const idx = __.findIndex(trips, {uuid: trip.uuid});
      //   if (idx < 0) {
      //     if (trip.aircraftReg === aircraftReg) {
      //       trips.push(trip);
      //     }
      //   } else {
      //     trips[idx] = trip;
      //   }
      // });
      // deleted.trips.forEach((trip) => {
      //   const idx = __.findIndex(trips, {uuid: trip.uuid});
      //   if (idx >= 0) {
      //     trips.splice(idx,1);
      //   }
      // });
      rows[aircraftReg] = [[]];

      let mx = [];
      if (aircraftMx && aircraftMx[aircraftReg] && Array.isArray(aircraftMx[aircraftReg])){
        mx = aircraftMx[aircraftReg].map((data,ii) => {
          const idx = __.findIndex(updated.maintenance, {iopsScheduledMxUuid: data.iopsScheduledMxUuid});
          if (idx >= 0) {
            return updated.maintenance[idx];
          }
          return data;
        });
      }

      const renderedTrips1 = [];
      const renderedTrips2 = [];
      const renderedTrips3 = [];

      const sortedTrips = __.sortBy(trips, ['scheduledDepartureTimeUtc']);
      let previousTrip = null;
      sortedTrips.forEach((_trip, ii) => {
        let trip = _trip;
        if (!editing && showOriginals && (trip.type === "TRIP" || trip.type === "EXTERNAL") && trip.tripState !== "SCHEDULED") {
          const scheduledDepartureTimeUtc = moment.utc(trip.std).valueOf();
          const scheduledArrivalTimeUtc = moment.utc(trip.sta).valueOf();
          const row = findFreeRow(rows[aircraftReg], scheduledDepartureTimeUtc, scheduledArrivalTimeUtc);
          rows[aircraftReg][row].push({startTime: scheduledDepartureTimeUtc, endTime: scheduledArrivalTimeUtc});
          renderedTrips1.push(
            <TripLeg key={`TripLegOrg_${i}_${ii}`}
              blockSize={blockSize}
              trip={{...trip, scheduledDepartureTimeUtc, scheduledArrivalTimeUtc, tripState: "ORIGINAL", ignore: true}}
              timelineStartsAt={startHour||0}
              row={row}
              backgroundColor={(i % 2 === 0?"#ffffff":"#fafafa")}
              colours={colours}
              tearStart={false}
              tearEnd={false}
              hideOffsetBox={true}
              toolTipPinned={toolTipPinned}
              canViewDetails={canViewDetails}
              detailAsPanel={detailAsPanel}
              selectedTripLegKey={selectedTripLegKey}
            />
          );
        }
        if (!previousTrip) previousTrip = {destinationAirportCode: sortedTrips[ii].originAirportCode};
        let nextTrip = ii<(sortedTrips.length - 1)?sortedTrips[ii + 1]:{originAirportCode: sortedTrips[ii].destinationAirportCode};
        if (trip.aircraftReg !== aircraftReg) return;
        const scheduledDepartureTimeUtc = moment.utc(trip.scheduledDepartureTimeUtc).valueOf();
        const scheduledArrivalTimeUtc = moment.utc(trip.scheduledArrivalTimeUtc).valueOf();
        const row = findFreeRow(rows[aircraftReg], scheduledDepartureTimeUtc, scheduledArrivalTimeUtc, (!editing && showOriginals && (trip.type === "TRIP" || trip.type === "EXTERNAL") && trip.tripState !== "SCHEDULED"?1:0));
        rows[aircraftReg][row].push({startTime: scheduledDepartureTimeUtc, endTime: scheduledArrivalTimeUtc});
        renderedTrips2.push(
          <TripLeg key={`TripLeg_${i}_${ii}`}
            blockSize={blockSize}
            trip={trip}
            timelineStartsAt={startHour||0}
            row={row}
            changed={trip.changed}
            editing={editing}
            canChange={trip.type !== "EXTERNAL" && canChange}
            backgroundColor={(i % 2 === 0?"rgba(0,0,0,0)":"rgba(0,0,0,0.05)")}
            colours={colours}
            tearStart={trip.type !== "EXTERNAL" && userClass === "OPERATOR" && previousTrip.destinationAirportCode !== trip.originAirportCode}
            tearEnd={trip.type !== "EXTERNAL" && userClass === "OPERATOR" && trip.destinationAirportCode !== nextTrip.originAirportCode}
            offsetTop={!editing && showOriginals && (trip.type === "TRIP" || trip.type === "EXTERNAL") && trip.tripState !== "SCHEDULED"?7:0}
            toolTipPinned={toolTipPinned}
            canViewDetails={canViewDetails}
            detailAsPanel={detailAsPanel}
            selectedTripLegKey={selectedTripLegKey}
          />
        );
        previousTrip = trip;
      });
      deletedTrips.forEach((trip,ii) => {
        const scheduledDepartureTimeUtc = moment.utc(trip.scheduledDepartureTimeUtc).valueOf();
        const scheduledArrivalTimeUtc = moment.utc(trip.scheduledArrivalTimeUtc).valueOf();
        const row = findFreeRow(rows[aircraftReg], scheduledDepartureTimeUtc, scheduledArrivalTimeUtc, 0);
        if (trip.tripState === "DELETED" || trip.tripState === "CANCELLED") {
          renderedTrips3.push(
            <TripLeg key={`TripLegDel_${i}_${ii}`}
              blockSize={blockSize}
              trip={trip}
              timelineStartsAt={startHour||0}
              row={row}
              changed={trip.changed}
              editing={editing}
              canChange={canChange}
              backgroundColor={(i % 2 === 0?"#ffffff":"#fafafa")}
              colours={colours}
              tearStart={false}
              tearEnd={false}
              offsetTop={0}
              toolTipPinned={toolTipPinned}
              canViewDetails={canViewDetails}
              detailAsPanel={detailAsPanel}
              selectedTripLegKey={selectedTripLegKey}
            />
          );
        }
      });

      const renderedTrips = [...renderedTrips1, renderedTrips2, renderedTrips3];

      const renderedMx =
      (mx||[]).map((data,ii) => {
        const {startCheckDate, endCheckDate} = data;

        const row = findFreeRow(rows[aircraftReg], moment.utc(startCheckDate).valueOf(), moment.utc(endCheckDate).valueOf());
        rows[aircraftReg][row].push({startTime: moment.utc(startCheckDate).valueOf(), endTime: moment.utc(endCheckDate).valueOf()});
        return (
          <Maintenance key={`Maintenance_${i}_${ii}`}
            blockSize={blockSize}
            data={data}
            timelineStartsAt={startHour||0}
            editing={editing}
            canChange={canChange}
            colours={colours}
            row={row}
            changed={data.changed}
            canViewDetails={canViewDetails}
            detailAsPanel={detailAsPanel}
          />
      )});
      const externalAircraft = aircraftReg.split('|').length > 1;

      return (
        <TripLine
          key={`tripLine_${i}`}
          renderedMx={renderedMx}
          renderedTrips={renderedTrips}
          aircraftReg={aircraftReg}
          externalAircraft={externalAircraft}
          backgroundColor={(i % 2 === 0?"rgba(0,0,0,0)":"rgba(0,0,0,0.05)")}
          blockSize={`${blockSize}`}
        />
      );
    })
    return rendered;
  }

  const preRenderedTrips = renderTrips({
    registrations,
    deltas,
    aircraftTrips: props.aircraftTrips,
    aircraftMx: props.aircraftMx,
    editing: props.editing,
    canChange: props.canChange,
    toolTipPinned,
    showOriginals: props.showOriginals,
    canViewDetails: props.canViewDetails,
    detailAsPanel: props.detailAsPanel,
    userClass: props.userClass
  });

  const timelineDrag = useRef({
    dragging: false,
    lastPos: null,
  })

  const renderScrollArea = () => {
    console.log('rendering scroll Area');
    let height = 2;
    registrations.forEach((aircraftReg, i) => {
      if (hiddenAircraft.indexOf(aircraftReg) >= 0) return;
      height += ((rows[aircraftReg]?.length||1) * 30) + 1;
    });

    const now = moment.utc();
    let nowPos = -1;
    if (now.isSameOrAfter(moment.utc(startHour)) && now.isSameOrBefore(moment.utc(endHour))){
      nowPos = (props.blockSize/60) * (now.diff(moment.utc(startHour),'minute')) + (props.blockSize<12?0:25) - props.blockSize;
    }

    if (isNaN(timelineSize)) return (<></>);
    return (
      <div style={{width: timelineSize, overflowX: "hidden"}}>

        <div style={{position:"absolute", display: windowDates.windowStartDate && showStartBlock?"block":"none", marginTop: 20, height: 20, minHeight: 20, maxHeight: 20, textAlign:"left", marginLeft: 0, fontWeight: "bold", fontSize: 15, backgroundColor: "#ffffff", zIndex: 10}}><span style={{paddingLeft: 3, }}>{windowDates.windowStartDate}</span></div>
        <div style={{position:"absolute", display: windowDates.windowEndDate && showEndBlock?"block":"none", marginTop: 20, left: timelineSize<clientWidth?timelineSize-60:(clientWidth - 60 + 82), height: 20, minHeight: 20, maxHeight: 20, width: 100, minWidth: 100, maxWidth: 100, textAlign:"right", marginLeft: 0, fontWeight: "bold", fontSize: 15, backgroundColor: "rgba(0,0,0,0)", zIndex: 10}}><span style={{paddingRight: 3, backgroundColor: "#ffffff"}}>{windowDates.windowEndDate}</span></div>
        <div style={{position:"absolute", marginTop: -1, left: "calc(100% - 40px)", width: 1, height: (height + 70), backgroundColor: "#909090", zIndex: 10, cursor: "pointer"}}>&nbsp;</div>
        {/* <ReactScrollWheelHandler
            upHandler={(e) => {
              e.preventDefault();
              eventBus.trigger('RouteView.scrollOffset', e.deltaY)
            }}
            downHandler={(e) => {
              e.preventDefault();
              eventBus.trigger('RouteView.scrollOffset', e.deltaY)
            }}
          > */}
        <div className={props.dragging?"grabbed":"canGrab"} style={{display:"flex", marginLeft: 0}} 
          onMouseDown={(e)=> {
            e.preventDefault();
            timelineDrag.current.lastPos = e.clientX; 
            timelineDrag.current.dragging = true;
          }} 
          onMouseUp={(e)=> {
            e.preventDefault();
            timelineDrag.current.dragging = false;
          }} 
          onMouseMove={(e)=> {
            e.preventDefault();
            if (timelineDrag.current.dragging) {
              const lastPos = timelineDrag.current.lastPos; 
              const delta = lastPos - e.clientX; 
              timelineDrag.current.lastPos = e.clientX;
              eventBus.trigger('RouteView.scrollOffset', delta);
            }
          }}
        >  
            {blockDays.map((blockDay,i) => (
              <DayHeader key={`DayHeader${i}`} blockSize={blockSize} blockDay={blockDay}/>
            ))}
        </div>
        {/* </ReactScrollWheelHandler> */}
        {nowPos > -1?
          <div style={{position:"relative", marginTop: 0, left: nowPos - 2, width: 4, height:0, zIndex: 10}}>
            <div style={{position:"absolute", marginTop: 0, left: 0, width: 4, height: height -2, backgroundColor: "rgba(233, 83, 0, 0.7)"}}>&nbsp;</div>
          </div>
        :<></>}
        {preRenderedTrips}
      </div>
    );
  }

  const renderedTimeWindow = renderScrollArea();

  const DragControl = (props) => {
    const { itemType, isDragging, item, initialOffset, currentOffset, x, y } = useDragLayer((monitor) => {
      const initialOffset = monitor.getInitialSourceClientOffset();
      const currentOffset = monitor.getSourceClientOffset();
      const {x, y} = {x: 0, y: 0, ...initialOffset, ...currentOffset};
      const item = monitor.getItem();
      return {
        item,
        itemType: monitor.getItemType(),
        initialOffset,
        currentOffset,
        isDragging: monitor.isDragging(),
        x,
        y,
      }
    });
    if (!isDragging || !initialOffset || !currentOffset || !item || !item.trip) return null;
    const {scheduledDepartureTimeUtc, scheduledArrivalTimeUtc, startCheckDate} = item.trip;
    const offsetX = currentOffset.x - initialOffset.x;
    const offsetXMinutes = offsetX / (blockSize / 60);
    const offsetTime = moment.utc(itemType==='MAINTENANCE'?startCheckDate:scheduledDepartureTimeUtc).add(offsetXMinutes, 'minutes');
    const offsetEndTime = moment.utc(itemType==='MAINTENANCE'?startCheckDate:scheduledArrivalTimeUtc).add(offsetXMinutes, 'minutes');
    const newMinutes = offsetTime.get('minutes');
    const fiveMinDiff = newMinutes % (dragTimeUnit||5);
    const newTime = offsetTime.subtract(fiveMinDiff, 'minute').format('DD-MMM-YY HH:mm');
    const newEndTime = itemType==='MAINTENANCE'?"":offsetEndTime.subtract(fiveMinDiff, 'minute').format('- HH:mm');
    return <div style={{position: "absolute", left: x, top: y-20, backgroundColor: "#ffffff", border: "1px solid #909090" }}>{newTime} {newEndTime}</div>
  }
  return (
    <div style={{backgroundColor: "#ffffff", height: "100%"}}>
      <div style={{display: "inline-block", position: "absolute", width: 80, border: "1px solid #909090", borderBottom: "none"}}>
        <div style={{width: 80, height: 70, borderBottom: "1px solid #909090"}}>&nbsp;</div>
        {registrations.map((aircraftReg, i) =>  {
          const externalAircraft = aircraftReg.split('|').length > 1;
          if (hiddenAircraft.indexOf(aircraftReg) >= 0) return null;
          let conflictBefore = null;
          let conflictAfter = null;
          const now = moment.utc().valueOf();
          if (!externalAircraft && rows[aircraftReg] && rows[aircraftReg].length > 1) {
            const middleTime = moment.utc(windowDates.windowMiddleDate).valueOf();
            rows[aircraftReg].forEach((row, i) => {
              if (i > 0) {
                row.forEach(trip => {
                  if (trip.endTime > now) {
                    if (trip.endTime < (middleTime - 60*60*1000) && (conflictBefore === null || conflictBefore < trip.endTime)) {
                      conflictBefore = trip.endTime;
                    }
                    if (trip.startTime > (middleTime + 60*60*1000) && (conflictAfter === null || conflictAfter > trip.startTime)) {
                      conflictAfter = trip.startTime;
                    }
                  }
                });
              }
            });
          }
          return (
          <div key={i} style={{backgroundColor: (i % 2 === 0?externalAircraft?"rgba(0,0,0,0.1)":"rgba(0,0,0,0)":externalAircraft?"rgba(0,0,0,0.15)":"rgba(0,0,0,0.05)"), width: 80, height: (((rows[aircraftReg]?.length||1) * 30)), borderBottom: "1px solid #909090"}}>
            <div style={{height:22}}><AircraftRegWithDefects aircraftReg={aircraftReg} canChange={props.canChange} canViewDetails={props.canViewDetails === true}/></div>
            {(!externalAircraft && (rows[aircraftReg]?.length||1) > 1)?(
            <div style={{paddingTop:4, height:22}}>
              <div style={{display: "inline-block", padding: 0, marginLeft: 5}}>
                <IconButton
                  style={{padding: 5}}
                  disabled={conflictBefore === null}
                  onClick={()=>{
                    eventBus.trigger('RouteView.scrollTo', moment(conflictBefore).toISOString());
                  }}
                >
                  <Icon>arrow_back_ios</Icon>
                </IconButton>
              </div>
              <div style={{display: "inline-block", padding: 0, paddingLeft: 10}}>
                <IconButton
                  style={{padding: 5}}
                  disabled={conflictAfter === null}
                  onClick={()=>{
                    eventBus.trigger('RouteView.scrollTo', moment(conflictAfter).toISOString());
                  }}
                >
                  <Icon>arrow_forward_ios</Icon>
                </IconButton>
              </div>
            </div>):null}
          </div>
        )})}
      </div>
      <div style={{display: "inline-block", marginLeft: 82, width: "calc(100% - 82px)", borderTop: "1px solid #909090"}}>
        <div
          style={{ overflow: "hidden", width: props.clientWidth, overflowX: "scroll"}}
          ref={props.scrollRef}
        >
          {renderedTimeWindow}
          <DragControl/>
        </div>
      </div>
    </div>
  )
}

export default memo(TimeWindow);
